export default {
  namespaced: true,
  state: {
    hotelDetailInfo: {}, //酒店列表进入详情数据
    backFromRemarkPage: false, //是否从点评页返回的酒店详情
  },
  mutations: {
    // 存储酒店详情信息
    setHotelDetailInfo(state, data) {
      state.hotelDetailInfo = data || {};
    },
    // 设置点评返回页
    setBackFromRemarkPage(state, data) {
      state.backFromRemarkPage = data || false;
    },
  },
  actions: {},
};
